import { Provider } from '@angular/core';
import { NgxImageCompressService } from 'ngx-image-compress';

import { WebModalService } from './web-modal.service';

export const PROVIDERS: Provider[] = [NgxImageCompressService, WebModalService];
